import React from "react";
import { Link } from "react-router-dom";
import { CheckCircle, Calendar, Home } from "lucide-react";
import { useNavigate } from "react-router-dom";
import SEO from "./SEO";

interface ThankYouProps {
  onCalClick?: () => void;
}

export default function ThankYou({ onCalClick }: ThankYouProps) {
  const navigate = useNavigate();

  const handleCalClick = (e: React.MouseEvent) => {
    e.preventDefault();
    if (onCalClick) {
      onCalClick();
    }
  };

  return (
    <div className="min-h-[60vh] flex flex-col items-center justify-center text-center px-4">
      <SEO
        title="One80Labs - Thank You"
        description="Thank you for your submission. We'll be in touch with your personalized AI recommendations soon."
        keywords={[
          "thank you",
          "submission confirmation",
          "AI recommendations",
          "One80Labs",
        ]}
      />
      <CheckCircle className="w-16 h-16 text-[#F98B3D] mb-6" />
      <h1 className="text-3xl font-bold text-gray-900 mb-4">
        Awesome! Your personalized AI Audit is on the way.
      </h1>
      <p className="text-lg text-gray-600 mb-8 max-w-md">
        We'll email you 3 custom AI recommendations for your business
      </p>
      <div className="flex space-x-4">
        <button
          onClick={handleCalClick}
          className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-white bg-[#F98B3D] hover:bg-[#e07a2c] transition-colors duration-200"
        >
          <Calendar className="h-5 w-5 mr-2" />
          Free Consultation
        </button>
        <Link
          to="/"
          className="inline-flex items-center px-6 py-3 border border-gray-300 text-base font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 transition-colors duration-200"
        >
          <Home className="h-5 w-5 mr-2" />
          Back to Lab
        </Link>
      </div>
    </div>
  );
}
